export default __webpack_public_path__ + "static/media/MR430.7a046fb9.png";